// extracted by mini-css-extract-plugin
export default {"footnote":"Footnote-module__footnote___Kq5vv"};